import { render, staticRenderFns } from "./ComptrollerFormV4.vue?vue&type=template&id=673e4de4"
import script from "./ComptrollerFormV4.vue?vue&type=script&lang=js"
export * from "./ComptrollerFormV4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports